import React, {useState, useContext, useEffect, useRef} from "react";
import ReactDOM from "react-dom";
import {useNavigate} from "react-router-dom";
import {StoreContext} from "../../../store/StoreContext";
import {BarcodeScanner} from "@capacitor-community/barcode-scanner";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBan, faFileExport, faQrcode} from "@fortawesome/free-solid-svg-icons";

const QrReader = () => {
  const {formsAD, formsAM, formsP} = useContext(StoreContext);
  const navigate = useNavigate();

  const [scanning, setScanning] = useState(false);
  const [templateId, setTemplateId] = useState(null);
  const [error, setError] = useState(false);
  const [form, setForm] = useState(null);
  const scanningRef = useRef(false);

  const checkPerssion = async () => {
    const status = await BarcodeScanner.checkPermission({force: true});
    if (status.granted) {
      return true;
    } else if (status.denied) {
      const _confirm = window.confirm(
        "Si desea otorgar permiso para usar su cámara, habilítelo en la configuración de la aplicación."
      );
      if (_confirm) BarcodeScanner.openAppSettings();
    } else {
      return false;
    }
  };

  const cleanupScanner = () => {
    document.querySelector("body").classList.remove("scanner-active");
    BarcodeScanner.showBackground();
    BarcodeScanner.stopScan();
    scanningRef.current = false;
  };

  const startScan = async () => {
    setScanning(true);
    scanningRef.current = true;
    setTemplateId(null);
    setForm(null);
    setError(false);
    document.querySelector("body").classList.add("scanner-active");
    BarcodeScanner.hideBackground();
    await checkPerssion();
    const result = await BarcodeScanner.startScan();
    if (result.hasContent) {
      const _templateId = Number(result.content);
      if (!isNaN(_templateId)) setTemplateId(_templateId);
    }
    cleanupScanner();
    setScanning(false);
  };

  const stopScan = () => {
    cleanupScanner();
    setScanning(false);
    setTemplateId(null);
    setForm(null);
    setError(false);
  };

  // Cleanup al desmontar: si el usuario navega mientras escanea
  useEffect(() => {
    return () => {
      if (scanningRef.current) cleanupScanner();
    };
  }, []);

  const goToForm = () => {
    let _rol = null;
    if (form.Titulo.includes("- Inspector")) _rol = "Inspector";
    else if (form.Titulo.includes("- Jefatura")) _rol = "Jefatura";

    if (!_rol) return;

    navigate(`/cermaq/roles/${_rol}/forms/${form?.TemplateId}`);
  };

  useEffect(() => {
    setError(false);

    if (!templateId) return;
    const forms = [...formsAM, ...formsAD, ...formsP];
    const _form = forms.find(f => f.TemplateId === templateId);
    if (!_form) return setError(true);

    setForm(_form);
  }, [templateId, formsAM, formsAD, formsP]);

  return (
    <>
      {scanning && ReactDOM.createPortal(
        <div className="scanner-overlay">
          <div className="scanner-frame" />
          <button type="button"
            className="scanner-cancel-btn btn btn-danger text-white px-4"
            onClick={() => stopScan()}
          >
            <FontAwesomeIcon icon={faBan} />
            <span className="ms-2">Cancelar</span>
          </button>
        </div>,
        document.body
      )}
      <div className="row h-100">
        <div className="col-12">
          {error && (
            <div className="alert alert-danger" role="alert">
              No se logró encontrar el formulario.
            </div>
          )}
          {form && (
            <div className="d-flex flex-column">
              <div className="alert alert-success mb-3" role="alert">
                ¡Formulario encontrado!
              </div>
              <div className="fs-5 mb-4">{form?.Titulo}</div>
              <button type="button"
                className="btn bg-primary text-white px-4 mx-auto"
                onClick={() => goToForm()}
              >
                <FontAwesomeIcon icon={faFileExport} />
                <span className="ms-2">Ir al formulario</span>
              </button>
            </div>
          )}
        </div>
        <div className="col-12 mt-auto d-flex">
          <button type="button"
            className="btn bg-primary text-white px-4 mx-auto"
            onClick={() => startScan()}
          >
            <FontAwesomeIcon icon={faQrcode} />
            <span className="ms-2">Escanear QR</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default QrReader;
